import Vue from 'vue'
import Vuex from 'vuex'

import * as langActions from '../actions/lang-actions'
import * as langMutations from '../mutations/lang-mutations'

import * as userActions from '../actions/user-actions'
import * as userMutations from '../mutations/user-mutations'

import * as uiActions from '../actions/ui-actions'
import * as uiMutations from '../mutations/ui-mutations'

import * as constants from '../constants/constants'
import * as english from '../lang/en.js'

import * as tripDetailsActions from '../actions/trip-details-actions'
import * as tripDetailsMutations from '../mutations/trip-details-mutations'

import * as configActions from '../actions/config-actions';
import * as configMutations from '../mutations/config-mutations'

Vue.use(Vuex)

// Obtain language short from localstorage if applicable
localStorage.getItem('lang') === null ? localStorage.setItem('lang' ,'EN' ) : localStorage.getItem('id')
let lsLang = localStorage.getItem('lang')

// Create languageList object
let spanishIcon = require('@/' + constants.constState.urlImg + 'flags/spanish.png')
let englishIcon = require('@/' + constants.constState.urlImg + 'flags/english.png')
let langList = [
  {name: 'ES', icon: spanishIcon},
  {name: 'EN', icon: englishIcon}
]


// UI Module
const UI = {
  namespaced: true,
  modules: {
    loaders: {
      namespaced: true,
      state: {
        table: false,
        finalizedTable: false,
        branches: false,
        loading: false,
        bLoading: false,
        loginLoader: false,
        sealChangesTable: false
      },
      actions: uiActions.loaderActions,
      mutations: uiMutations.loaderMutations
    },
    sidebar: {
      namespaced: true,
      state: {
        drawer: false
      },
      actions: uiActions.sidebarActions,
      mutations: uiMutations.sidebarMutations
    },
    appBar: {
      namespaced: true,
      state: {
        title: null
      },
      actions: uiActions.appBarActions,
      mutations: uiMutations.appBarMutations
    },
    flags: {
      namespaced: true,
      state: {
        fileNotFoundDialog: false
      },
      actions: uiActions.flagActions,
      mutations: uiMutations.flagMutations
    }
  }
}

// Langs Module
const langs = {
  namespaced: true,
  state: {
    langNames: langList,
    language: english,
    short: lsLang,
    id: 1
  },
  actions: langActions.actions,
  mutations: langMutations.mutations
}

// User module
const userModule = {
  namespaced: true,
  state: {
    userInfo: {
    },
    dashboardWasLoaded: false,
    branches: [],
    activeTrips: [],
    finalizedTrips: [],
    finalizedTripsPagination: {
      perPage: 10,
      currentPage: 1,
      lastPage: 1,
      totalItems: 1
    },
    isLogged: false,  
  },
  actions: userActions.actions,
  mutations: userMutations.mutations
}

// Configuration module
const configurationModule = {
  namespaced: true,
  state: {
    defaultConfig: [],
    tripNotConfig: {
      phone_number: '',
      lada_number: '',
      enabled: false,
      tripId: 0
    }
  },
  actions: configActions.actions,
  mutations: configMutations.mutations
} 

// Trip details module
const tripDetailsModule = {
  namespaced: true,
  state: {
    tripId: null,
    trip: null,
    truckInformation: null,
    trailerInformation: null,
    driverActivity: null,
    reportTime: null,
    routeInformation: null,
    sealChanges: [],
    tripRoutePath: null
  },
  actions: tripDetailsActions.actions,
  mutations: tripDetailsMutations.mutations
}

// ConstModule
const constModule = {
  namespaced: true,
  state: constants.constState
}

export const store = new Vuex.Store({
  modules: {
    langs: langs,
    UI: UI,
    constantsModule: constModule,
    userModule,
    tripDetailsModule,
    configurationModule
  }
})

// Initial state sets
store.dispatch('langs/languageSet', lsLang, { root: true })